import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AllocateResourcesComponent } from './components/allocate-resources/allocate-resources.component';
import { PageComponent } from './components/page/page.component';

const routes: Routes = [
	{
		path: '',
		component: PageComponent,
	},
	{
		path: 'form',
		component: AllocateResourcesComponent,
	},
	{
		path: 'form/:id',
		component: AllocateResourcesComponent,
	},
	{
		path: '**',
		redirectTo: ''
	}
];

@NgModule({
	declarations: [],
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class ProyectosRoutingModule {}
